import script from "./personalPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./personalPreview.vue?vue&type=script&setup=true&lang=js"

import "./personalPreview.vue?vue&type=style&index=0&id=dac63956&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dac63956"]])

export default __exports__